import React from "react";
import "./ContactPage.scss";
import ColumnLayout from "../../components/Layouts/ColumnLayout";
import Icon from "../../components/Icon/Icon";
import Headline from "../../components/Text/Headline";
import RowLayout from "../../components/Layouts/RowLayout";

const ContactPage = () => {
  return (
    <div className="flexColumn centerContent" style={{ width: '100vw', height: '100vh', padding: 32 }}>
      <ColumnLayout gap={32} isCard>
        <Icon 
            icon={'Contact'} 
            className={'float-top-right resume-card-icon'}
        />
        <Headline size={3} secondary>Contact</Headline>
        <ContactInfo
          value="Justingistdesigner@gmail.com"
          iconString="Email"
          title="Email Address"
        />
        <ContactInfo
          title="LinkedIn Profile"
          iconString="Linkedin"
          link="https://www.linkedin.com/in/justin-gist-270862b2"
          value="Profile Link"
        />
        <ContactInfo
          title="Phone Number"
          value="(407)-929-3184"
          iconString="Phone"
        />
      </ColumnLayout>
    </div>
  );
};
export default ContactPage;

const ContactInfo = ({
  title,
  iconString,
  style,
  link,
  value
}: {
  title: string;
  iconString: string;
  style?: any;
  link?: string;
  value: string;
}) => {
  const valueElement = (
      <Headline size={3} style={{
        ...style,
        width: 'auto',
        display: 'flex',
        alignItems: 'flex-start',
      }}>
        {value}
      </Headline>
  );
  return (
    <ColumnLayout gap={8} className="items-start">
      <RowLayout gap={16} noWrapping>
        <Icon className="text-headline" icon={iconString} />
        <Headline truncate size={5} style={style}>
          {title}
        </Headline>
      </RowLayout>
      {link ? (
        <a 
          href={link} 
          target="_blank" 
          rel="noopener noreferrer">
          {valueElement}
        </a>
      ) : valueElement}
    </ColumnLayout>
  );
};